import type { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const HeaderLoadingSkeleton: FC<{ title: string }> = ({ title }) => (
  <div className="flex items-center py-5 px-12 mb-6 rounded-xl bg-primary-100">
    <div className="pr-6">
      <h1 className="font-degular text-primary-200 font-bold first-letter:capitalize tracking-[-.045em] line-height-[1.3] text-5xl">
        {title}
      </h1>
    </div>

    <div className="flex-1 flex items-center space-x-6 px-10">
      <div className="w-[30%]">
        <Skeleton height={6} />
        <Skeleton height={20} />
      </div>

      <div className="w-[30%]">
        <Skeleton height={6} />
        <Skeleton height={20} />
      </div>
    </div>

    <div className="w-[27%] flex items-center space-x-3 justify-end">
      <Skeleton height={44} width={150} borderRadius={10} />
      <Skeleton height={44} width={44} borderRadius={10} />
      <Skeleton height={44} width={44} borderRadius={10} />
    </div>
  </div>
);

export default HeaderLoadingSkeleton;
